import React from 'react';
import { BatteryCharging, TrendingUp, Zap, Globe, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';
import { valuePropositions } from '../../data/mock';

const iconMap = {
  BatteryCharging: BatteryCharging,
  TrendingUp: TrendingUp,
  Zap: Zap,
  Globe: Globe
};

const ValuePropositionSection = () => {
  const scrollToForm = () => {
    document.getElementById('lead-form')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-12 sm:py-16 lg:py-24 bg-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-16">
          <span className="inline-block px-3 py-1 rounded-full bg-cyan-900/50 text-cyan-300 text-xs sm:text-sm font-medium mb-3 sm:mb-4 border border-cyan-700/50">
            Unser Leistungsversprechen
          </span>
          <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-white mb-3 sm:mb-4">
            Konkrete Vorteile für Ihr Projekt
          </h2>
          <p className="text-sm sm:text-base text-slate-300 max-w-2xl mx-auto px-4">
            Steigern Sie den Wert Ihrer Immobilie und schaffen Sie nachhaltige Erlösquellen.
          </p>
        </div>

        {/* Value Cards Grid */}
        <div className="grid sm:grid-cols-2 gap-4 sm:gap-6 mb-8 sm:mb-12">
          {valuePropositions.map((value, index) => {
            const Icon = iconMap[value.icon];
            return (
              <div 
                key={index}
                className="group p-5 sm:p-8 rounded-xl bg-slate-700/50 border border-slate-600 hover:border-slate-500 transition-all"
              >
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-emerald-900/50 flex items-center justify-center mb-4 sm:mb-6 border border-emerald-700/50">
                  <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-emerald-400" />
                </div>
                
                <h3 className="text-base sm:text-lg font-semibold text-white mb-2 sm:mb-3">{value.title}</h3>
                <p className="text-sm sm:text-base text-slate-300 leading-relaxed">{value.description}</p>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center">
          <Button 
            onClick={scrollToForm}
            className="w-full sm:w-auto bg-cyan-600 text-white hover:bg-cyan-700 font-medium text-sm sm:text-base px-6 sm:px-8 py-4 sm:py-5 rounded-lg transition-colors group"
          >
            <span className="sm:hidden">Potenzial berechnen</span>
            <span className="hidden sm:inline">Jetzt Potenzial berechnen</span>
            <ArrowRight className="ml-2 w-4 h-4 sm:w-5 sm:h-5 transition-transform group-hover:translate-x-1" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ValuePropositionSection;
